export type ClickEventType = React.MouseEvent<HTMLButtonElement | HTMLDivElement | HTMLSpanElement | HTMLAnchorElement>;

export type ProgressEventType = {
  loaded: number;
  total: number;
};

export type History = {
  // RouteComponentProps
  push: (url: string, state?: any) => {};
};

export interface DedicatedRouteProps {
  isdedicatedJourney: boolean;
  history: History;
  [x: string]: any;
}

export enum FileTypes {
  xlsx = 'xlsx',
  pdf = 'pdf',
  png = 'png',
  jpg = 'jpg',
  jpeg = 'jpeg'
}

export enum FileTypesAlias {
  xlsx = '.XLS',
  pdf = '.PDF',
  png = '.PNG',
  jpg = '.JPG',
  jpeg = '.JPEG'
}

export const FileFormats = {
  [FileTypes.xlsx]: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
  [FileTypes.pdf]: 'application/pdf',
  [FileTypes.png]: 'image/png',
  [FileTypes.jpg]: 'image/jpg',
  [FileTypes.jpeg]: 'image/jpeg'
};

export enum FileErrors {
  type = 'Invalid file format. Try to re-upload the correct format',
  size = 'Invalid file size. File size must be maximum 1Mb'
}

export enum EnumRecipientType {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  BOTH = 'BOTH'
}
